import { memo } from 'react';
import { trans } from '@lingoda/i18n';
import type { Path } from '@lingoda/router';
import { createDate, getYear } from '@lingoda/dates';
import { Box } from '../Box';
import { Grid } from '../GridNext';
import { Typography } from '../Typography';
import { Button } from '../../buttons';
import { colorsPalette } from '../../theme';

const currentYear = getYear(createDate());

interface Props {
    contactPath: Path;
}

const AppFooterComponent = ({ contactPath, children }: React.PropsWithChildren<Props>) => {
    return (
        <Box component="footer" overflow="hidden" mt={{ xs: 13, sm: 3 }} pt={1} pb={1}>
            <Grid
                container
                alignItems="center"
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 1, sm: 0 }}
            >
                <Grid flexGrow="2">
                    <Typography variant="body3" htmlColor={colorsPalette.blackAlpha[70]} py={1}>
                        © {currentYear} Lingoda GmbH
                    </Typography>
                </Grid>
                <Grid>{children}</Grid>
                <Grid>
                    <Button variant="text" size="small" href={contactPath}>
                        {trans('contact-us', {}, 'public-common')}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export const AppFooter = memo(AppFooterComponent);
